import { CustomerStory } from '@/content/customerStories/customerStories.types';

import { CustomerStoryFilterObject } from '.';

export const filterCustomerStories = (
	results: CustomerStory[],
	filters: CustomerStoryFilterObject,
	committedState: 'committedActive' | 'stagedActive',
) => {
	const filteredProducts = Object.entries(filters.product).reduce(
		(acc: string[], [subFilterName, subFilterObject]) => {
			if (subFilterObject[committedState]) {
				acc.push(subFilterName);
			}
			return acc;
		},
		[],
	);
	const filteredIndustries = Object.entries(filters.industry).reduce(
		(acc: string[], [subFilterName, subFilterObject]) => {
			if (subFilterObject[committedState]) {
				acc.push(subFilterName);
			}
			return acc;
		},
		[],
	);

	const filteredSolutions = Object.entries(filters.solution).reduce(
		(acc: string[], [subFilterName, subFilterObject]) => {
			if (subFilterObject[committedState]) {
				acc.push(subFilterName);
			}
			return acc;
		},
		[],
	);
	const filteredRegions = Object.entries(filters['more filters']).reduce(
		(acc: string[], [subFilterName, subFilterObject]) => {
			if (subFilterObject.grouping === 'region') {
				if (subFilterObject[committedState]) {
					acc.push(subFilterName);
				}
			}
			return acc;
		},
		[],
	);
	const filteredTeamSize = Object.entries(filters['more filters']).reduce(
		(acc: string[], [subFilterName, subFilterObject]) => {
			if (subFilterObject.grouping === 'team size') {
				if (subFilterObject[committedState]) {
					acc.push(subFilterName);
				}
			}
			return acc;
		},
		[],
	);
	const filteredMarketplaceApps = filters['more filters']['Marketplace apps']?.[committedState];
	const filteredSolutionPartner = filters['more filters']['Solution partner']?.[committedState];

	const filterByCategory = (selectedCategoryValues: string[], customerValues: string[] = []) => {
		if (selectedCategoryValues.length > 0) {
			if (customerValues?.length > 0) {
				// Include if filter is applied and this company has that industry
				if (
					selectedCategoryValues.filter((selected) => {
						return customerValues.includes(selected);
					}).length > 0
				) {
					return true;
				}
			}

			// Remove this item if there is a filter applied but this customer does not have the appropriate value
			return false;
		}

		// Include all items if no filter has been requested
		return true;
	};
	const includeIfExists = (isEnabled = false, customerValues: string[] = []) => {
		if (isEnabled) {
			return customerValues?.length > 0;
		}

		return true;
	};

	const filteredResults = results
		?.filter((customerStory) =>
			filterByCategory(
				filteredIndustries,
				customerStory.customerCompany?.industry?.map((industry) => industry.name ?? ''),
			),
		)
		.filter((customerStory) =>
			filterByCategory(
				filteredProducts,
				customerStory.products?.map((product) => product.name ?? ''),
			),
		)
		.filter((customerStory) =>
			filterByCategory(
				filteredSolutions,
				customerStory.solutions?.map((solution) => solution.name ?? ''),
			),
		)
		.filter((customerStory) =>
			filterByCategory(filteredRegions, [customerStory.customerCompany?.region?.name ?? '']),
		)
		.filter((customerStory) =>
			filterByCategory(filteredTeamSize, [
				customerStory.customerCompany?.organizationSize?.name ?? '',
			]),
		)
		.filter((customerStory) =>
			includeIfExists(
				filteredMarketplaceApps,
				customerStory.marketplaceApps?.map((app) => app.name ?? ''),
			),
		)
		.filter((customerStory) =>
			includeIfExists(
				filteredSolutionPartner,
				customerStory.solutionPartners?.map((partner) => partner.name ?? ''),
			),
		);

	return filteredResults;
};
